import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlValueAccessorMixin } from '../../../core/mixins/ControlValueAccessorMixin';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { ControlValueAccessorUtils } from '../../../core/utils/ControlValueAccessorUtils';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-switch',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ControlValueAccessorUtils.getProvider(SwitchComponent)]
})
export class SwitchComponent extends ControlValueAccessorMixin<boolean, BaseComponent>(BaseComponent) {

  @Input() text: string;
}
